module.exports = __webpack_public_path__ + "static/media/ไฟล์ข้อมูลผู้บริจาคเบี้ยยังชีพผู้สูงอายุver2.0.593828d7.xlsx";